import React from 'react';
import PropTypes from 'prop-types';
import PhoneInput from 'components/form/InputFields/MobianPhoneInput/PhoneInput';
import RenderCategoriesInputField from 'components/form/InputFields/AutoCompleteField/RenderCategoriesInputField';
import RenderProviderInputField from 'components/form/InputFields/AutoCompleteField/RenderProviderInputField';
import RenderSubCategoriesInputField from 'components/form/InputFields/AutoCompleteField/RenderSubCategoriesInputField';
import RenderTextInputField from 'components/form/InputFields/RenderTextInputField';
import SubmitButton from 'components/button/SubmitButton';
import compose from 'recompose/compose';
import rolesHelper from 'helpers/roles';
import translate from 'components/hoc/translate';
import validations from 'helpers/forms/validations';
import { ButtonWrapper, FormWrapper, Item, Row, Section } from 'components/ui/table/elements';
import { Field, reduxForm, formValueSelector } from 'redux-form';
import { connect } from 'react-redux';

class ProductsCreate extends React.Component {
    render() {
        const {
            categoryId,
            handleSubmit,
            handleSubmitForm,
            invalid,
            pristine,
            submitting,
            translate,
        } = this.props;

        return (
            <FormWrapper>
                <form onSubmit={ handleSubmit(handleSubmitForm) }>
                    <Section title={ translate('resources.products.forms.general') }>
                        <Row>
                            <Item>
                                <Field
                                    component={ RenderTextInputField }
                                    fullWidth={ true }
                                    label={ translate('resources.products.fields.title') }
                                    name='title'
                                    validate={ validations.required }
                                />
                            </Item>
                        </Row>

                        <Row>
                            <Item>
                                <Field
                                    component={ RenderCategoriesInputField }
                                    fullWidth={ true }
                                    label={ 'resources.products.fields.category_id' }
                                    name='category_id'
                                    validate={ validations.required }
                                />
                            </Item>
                        </Row>

                        { categoryId &&
                            <Row>
                                <Item>
                                    <Field
                                        component={ RenderSubCategoriesInputField }
                                        categoryId={ categoryId }
                                        fullWidth={ true }
                                        label={ 'resources.products.fields.subcategory_id' }
                                        name='subcategory_id'
                                    />
                                </Item>
                            </Row>
                        }
                    </Section>

                    <Section title={ translate('resources.products.forms.provider') }>
                        <Row>
                            <Item>
                                <Field
                                    component={ RenderProviderInputField }
                                    fullWidth={ true }
                                    label={ translate('resources.products.fields.provider_id') }
                                    name='provider_id'
                                    searchParams={ {
                                        role_id: [
                                            rolesHelper.getProviderRoleId(),
                                        ],
                                        size: '12',
                                        sort_by: 'name',
                                        sort_direction: 'asc',
                                    } }
                                    reference='accounts'
                                    optionValue='id'
                                    searchBy='name'
                                    source='provider_id'
                                    validate={ validations.required }
                                />
                            </Item>
                        </Row>

                        <Row>
                            <Item>
                                <Field
                                    component={ PhoneInput }
                                    fullWidth={ true }
                                    label={ translate('resources.products.fields.phone') }
                                    name='phone'
                                    source='phone'
                                />
                            </Item>
                        </Row>
                    </Section>

                    <Section>
                        <Row>
                            <ButtonWrapper>
                                <SubmitButton
                                    disabled={ pristine || submitting || invalid }
                                    loading={ submitting }
                                />
                            </ButtonWrapper>
                        </Row>
                    </Section>
                </form>
            </FormWrapper>
        );
    }
}

ProductsCreate.propTypes = {
    categoryId: PropTypes.number,
    handleSubmit: PropTypes.func.isRequired,
    handleSubmitForm: PropTypes.func.isRequired,
    invalid: PropTypes.bool,
    pristine: PropTypes.bool,
    submitting: PropTypes.bool,
    translate: PropTypes.func.isRequired,
};

const mapStateToProps = (state, props) => {
    const selector = formValueSelector(props.form);

    const hasCategoryId = selector(state, 'category_id');

    return {
        categoryId: hasCategoryId,
    };
};

const enhance = compose(
    translate,
    reduxForm(),
    connect(
        mapStateToProps,
        null,
    ),
);

export default enhance(ProductsCreate);



// WEBPACK FOOTER //
// ./src/pages/products/create/ProductsCreate.js